import React, { RefObject } from 'react'
import { Divider, FormControl, Grid, Stack, Typography } from '@mui/material'
import { IProductWarrantyClaim, ProductWarrantyClaimStatus } from '@cbgms/api'
import { Dropdown, DropdownOption, Form, FormProps } from '@carsys/form'
import { useStyles } from '../styles/form.style'
import WholesalerFields from './WholesalerFields'
import { SubmitButton } from './FormLayout/SubmitButton'
import CompanyProductDetailsViewSection from './CompanyProductDetailsViewSection'
import WarrantyDetailsViewSection from './WarrantyDetailsViewSection'
import VehicleDetailsViewSection from './VehicleDetailsViewSection'
import { useTranslation } from 'react-i18next'
import { formatDateTime } from '@cbgms/base/utils/datetime'
import { useFormikContext } from 'formik'

export const ProductWarrantyClaimForm: React.FC<FormProps<ProductWarrantyClaimFormValues, ProductWarrantyClaimFormValues>> = ({
  children,
  ...formProps
}) => {
  return <Form {...formProps}>{children}</Form>
}

interface AllProductWarrantyClaimFormFieldProps {
  printContentRef: RefObject<HTMLDivElement>
}

export const AllProductWarrantyClaimFormFields = ({ printContentRef }: AllProductWarrantyClaimFormFieldProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { values: formValues } = useFormikContext<IProductWarrantyClaim>()

  return (
    <Grid ref={printContentRef} direction='column' container spacing={2} className={classes.form}>
      <Stack direction='column' spacing={2}>
        <FormControl fullWidth>
          <Dropdown label={t('productWarrantyClaim.status')} name='Status' className={classes.inputSelectField} required>
            <DropdownOption value={ProductWarrantyClaimStatus.Sent}>{t('Enum.ProductWarrantyClaimStatus_Sent')}</DropdownOption>
            <DropdownOption value={ProductWarrantyClaimStatus.InProgress}>{t('Enum.ProductWarrantyClaimStatus_InProgress')}</DropdownOption>
            <DropdownOption value={ProductWarrantyClaimStatus.Finalised}>{t('Enum.ProductWarrantyClaimStatus_Finalised')}</DropdownOption>
            <DropdownOption value={ProductWarrantyClaimStatus.Rejected}>{t('Enum.ProductWarrantyClaimStatus_Rejected')}</DropdownOption>
          </Dropdown>
        </FormControl>
        <Grid item container>
          <Grid item xs={3}>
            <Typography fontWeight={500}>{t('productWarrantyClaim.created_on')}</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography>{formatDateTime(formValues.CreatedAt, 'DD/MM/YYYY')}</Typography>
          </Grid>
        </Grid>
        <CompanyProductDetailsViewSection />
        <WarrantyDetailsViewSection />
        <VehicleDetailsViewSection />
        <WholesalerFields />
        <Grid item sx={{ my: 2 }}>
          <Divider className={classes.widthPercentage} />
        </Grid>
        <Grid item sx={{ mt: 2, pt: 2 }} className={classes.noBreakPrintOnly}>
          <FormControl fullWidth>
            <Dropdown label={t('productWarrantyClaim.status')} name='Status' className={classes.inputSelectField} required>
              <DropdownOption value={ProductWarrantyClaimStatus.Sent}>{t('Enum.ProductWarrantyClaimStatus_Sent')}</DropdownOption>
              <DropdownOption value={ProductWarrantyClaimStatus.InProgress}>
                {t('Enum.ProductWarrantyClaimStatus_InProgress')}
              </DropdownOption>
              <DropdownOption value={ProductWarrantyClaimStatus.Finalised}>{t('Enum.ProductWarrantyClaimStatus_Finalised')}</DropdownOption>
              <DropdownOption value={ProductWarrantyClaimStatus.Rejected}>{t('Enum.ProductWarrantyClaimStatus_Rejected')}</DropdownOption>
            </Dropdown>
          </FormControl>
        </Grid>
      </Stack>
      <Stack direction='row' justifyContent='center' sx={{ mt: 2, pt: '16px', pb: '16px' }} className={classes.noPrint}>
        <SubmitButton>{t('productWarrantyClaim.save')}</SubmitButton>
      </Stack>
    </Grid>
  )
}

export type ProductWarrantyClaimFormValues = IProductWarrantyClaim
